// extracted by mini-css-extract-plugin
export var accountNav = "account-nav-module--account-nav--YE+C5";
export var active = "account-nav-module--active--BB8e1";
export var labelBox = "account-nav-module--label-box--OTpPI";
export var link = "account-nav-module--link--Zll3q";